module.exports = __webpack_public_path__ + "static/media/modal-success.1f6bea9e.svg";